import React, { useMemo, useState } from 'react'
import Style from '../mappingUi.module.css'
const CUSTOM_VALUE = '__custom__'
const MappingSelect = ({
    inputId,
    options,
    value,
    fallbackLabel,
    placeholder,
    customLabel,
    customPlaceholder,
    hasError,
    isDisabled,
    onChange
}) => {
    const [isCustom, setIsCustom] = useState(false)
    const visibleOptions = useMemo(() => {
        if (value === '' || options.some((option) => option.value === value)) {
            return options
        }
        return [{ value, label: fallbackLabel || value }, ...options]
    }, [options, value, fallbackLabel])
    const handleSelect = (event) => {
        const selected = event.target.value
        if (selected === CUSTOM_VALUE) {
            setIsCustom(true)
            onChange('', null)
            return
        }
        const match = visibleOptions.find((option) => option.value === selected)
        onChange(selected, match || null)
    }
    const handleCustomInput = (event) => {
        onChange(event.target.value, null)
    }
    const exitCustom = () => {
        setIsCustom(false)
        onChange('', null)
    }
    const controlClass = [Style.control, hasError ? Style.controlError : ''].join(' ').trim()
    if (isCustom) {
        return (
            <div className={Style.customField}>
                <input
                    id={inputId}
                    type="text"
                    className={controlClass}
                    placeholder={customPlaceholder}
                    value={value}
                    disabled={isDisabled}
                    autoFocus
                    onChange={handleCustomInput}
                />
                <button
                    type="button"
                    className={Style.customExit}
                    title="Back to the list"
                    aria-label="Back to the list"
                    onClick={exitCustom}
                >
                    &times;
                </button>
            </div>
        )
    }

    return (
        <select
            id={inputId}
            className={controlClass}
            value={value}
            disabled={isDisabled}
            onChange={handleSelect}
        >
            <option value="">{placeholder}</option>
            {visibleOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
            ))}
            {customLabel ? <option value={CUSTOM_VALUE}>{customLabel}</option> : null}
        </select>
    )
}

export default MappingSelect
